export default {"src":"/_next/static/media/GME.c751d750.svg","height":18,"width":18};